import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { ClienteFincaLoteResponse } from "../../../../../modulos/terceros/response/ClienteFincaLoteResponse";
import { BaseFullScreenModalRender } from "../../../../base/modal/BaseFullScreenModalRender";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { HistoricoLoteRender } from "../detail/HistoricoLoteRender";

/** Modal a pantalla completa (solo lectura) con el histórico de movimientos de
 *  un potrero. Se abre desde el bottom-sheet del mapa de ganadería; al volver,
 *  el mapa queda como estaba. */
export class HistoricoLoteModalRender extends BaseFullScreenModalRender {
  protected readonly elementId = "historicoLoteModal";

  /** @param _lote Lote cuyo histórico se muestra. */
  constructor(private readonly _lote: ClienteFincaLoteResponse) {
    super();
  }

  protected get title(): string {
    return "Histórico";
  }

  protected get subtitle(): string | undefined {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    return `${finca.nombreFinca} · ${this._lote.nombreLote}`;
  }

  protected getContent(): IConnectRender {
    return new HistoricoLoteRender(this._lote);
  }
}
